// Aides de gating côté client, partagées par GatedButton et toute UI de permission sur mesure.
//
// `tokenLabel` transforme un jeton de permission (feature:x:read|write|purge, content:x:read|write)
// en libellé humain affichable dans une modale : le libellé FR du catalogue /api/permissions/catalog
// plus l'action entre parenthèses. La purge est un cas particulier : le catalogue ne modélise que
// lecture/écriture, mais des jetons purge existent (ex. feature:deleted-pages:purge) : on réutilise
// alors le libellé de la fonctionnalité avec « (purge) ». Catalogue nul ou incomplet (en cours de
// chargement, ou test sans catalogue) → repli sur le jeton brut.
import { usePermissions, type PermissionCatalog } from "./PermissionsContext";

const ACTION_FR: Record<string, string> = {
	read: "lecture",
	write: "écriture",
	purge: "purge"
};

/** Libellé humain d'un jeton de permission : « <label> » (lecture|écriture|purge), sinon le jeton brut. */
export function tokenLabel(catalog: PermissionCatalog | null | undefined, token: string): string {
	const [resource, key, action] = (token ?? "").split(":");
	const actionFr = ACTION_FR[action ?? ""];
	if (!catalog || !resource || !key || !actionFr) return token;
	if (resource === "feature") {
		const feature = (catalog.features ?? []).find((f) => f.key === key);
		return feature ? `« ${feature.label} » (${actionFr})` : token;
	}
	if (resource === "content") {
		const type = (catalog.contentTypes ?? []).find((t) => t.key === key);
		return type ? `« ${type.label} » (${actionFr})` : token;
	}
	return token;
}

/** État de gating pour UN jeton : autorisé ? + le libellé FR pour la modale « Permission manquante ». */
export function useGate(token: string): { allowed: boolean; label: string } {
	const { can, catalog } = usePermissions();
	return { allowed: can(token), label: tokenLabel(catalog, token) };
}
